var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"privacyStyles"},[_c('h1',[_vm._v("用户许可协议")]),_c('privacyVue',{staticClass:"content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }